<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="600">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Grupo
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="justify-center mt-7">
            <v-col cols="6">
              <v-text-field
                :value="content.origem.nome | uppercase"
                label="Origem"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="content.nome"
                label="Nome do Grupo"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                :value="content.descricao"
                label="Descricao do Grupo"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="justify-center">
            <v-col cols="12">
              <v-data-table
                class="mt-5"
                :headers="headers"
                :items="content.usuarios"
                :items-per-page="10"
                :footer-props="$footerProps">
              </v-data-table>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Grupo } from '~/commons/classes/grupo';

export default {
  props: new DialogProps(Grupo),
  filters: {
    uppercase: (v) => v?.toUpperCase()
  },
  data: () => ({
    headers: [
      { text: 'CPF', value: 'cpf' },
      { text: 'Nome', value: 'nome' },
      { text: 'Cargo/Função', value: 'funcao' }
    ]
  })
}
</script>